import { useQuery } from "@tanstack/react-query";
import { CloudForwarderForwarders } from "@graylog/enterprise-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const FORWARDERS_CONFIGURATION_QUERY_KEY = "forwarders_configuration_hostname";
const DEFAULT_DATA = {};
const getConfiguration = async () => CloudForwarderForwarders.getConfiguration();
const useForwardersConfiguration = () => {
  const { data: responseData, isLoading } = useQuery({
    queryKey: [FORWARDERS_CONFIGURATION_QUERY_KEY],
    queryFn: () => defaultOnError(
      getConfiguration(),
      i18n.t("notifications.load_forwarders_configuration_failed", { ns: "enterprise_forwarder" }),
      i18n.t("notifications.load_forwarders_configuration_failed_title", { ns: "enterprise_forwarder" })
    )
  });
  return {
    data: responseData != null ? responseData : DEFAULT_DATA,
    isLoading
  };
};
export default useForwardersConfiguration;
